import { createTheme, ThemeOptions } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";

const themeOptions: ThemeOptions = {
    typography: {
        fontFamily: '"Inter", sans-serif',
    },
    // other theme customizations...

    palette: {
        primary: {
            main: "#C3FF36",
            contrastText: "#000000",
        },
        secondary: {
            main: "#000000",
            contrastText: "#FFFFFF",
        },
    },
    components: {
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: "#000000", // Custom indicator color
                    height: "3px",
                    borderRadius: "3px",
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "16px",
                    color: "#555", // Default tab color
                    "&.Mui-selected": {
                        color: "#000000", // Active tab color
                    },
                    "&:hover": {
                        color: "#000000", // Hover color
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: "none", // Disable box-shadow
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    borderRadius: "9999px",
                    boxShadow: "none",
                    padding: "6px 18px",
                    "&:hover": {
                        boxShadow: "none",
                    },
                },
                containedSecondary: {
                    border: "1px solid black",
                    "&:hover": {
                        backgroundColor: "#FFFFFF",
                        color: "#000000",
                    },
                },
            },
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    border: "1px solid black",
                    borderRadius: "9999px",
                },
                grouped: {
                    borderColor: "black !important",
                    "&:not(:last-of-type)": {
                        borderRight: "1px solid black !important",
                    },
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    borderRadius: "9999px",
                    border: "0px solid black",
                    textTransform: "none",
                    backgroundColor: "white",
                    color: "black",
                    "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: "black !important",
                        color: "white !important",
                    },
                    "&:hover": {
                        backgroundColor: "#f0f0f0",
                    },
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                    fontSize: "1rem",
                    padding: "10px 20px",
                    textAlign: "center",
                    boxShadow: "none",
                },
                standardError: {
                    backgroundColor: "#FF365E",
                    color: "#FFFFFF",
                },
                standardSuccess: {
                    backgroundColor: "#e8f5e9",
                    color: "#2e7d32",
                    border: "1px solid #2e7d32",
                },
                standardWarning: {
                    backgroundColor: "#fff8e1",
                    color: "#ed6c02",
                    border: "1px solid #ed6c02",
                },
                standardInfo: {
                    backgroundColor: "#e3f2fd",
                    color: "#0288d1",
                    border: "1px solid #0288d1",
                },
                icon: {
                    color: "currentColor !important",
                    fontSize: "1.5rem",
                },
                action: {
                    color: "inherit",
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black !important",
                    },
                },
                input: {
                    color: "black",
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    "&:before": {
                        borderBottom: "1px solid black",
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: "1px solid black",
                    },
                    "&.Mui-focused:before": {
                        borderBottom: "2px solid black !important",
                    },
                },
                input: {
                    color: "black",
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: "black",
                    "&.Mui-focused": {
                        color: "black !important",
                    },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    padding: "0px",
                    fontFamily: '"Inter", sans-serif',
                    "& .MuiSvgIcon-root": {
                        fontFamily: '"Inter", sans-serif',
                    },
                    "& .MuiFormControlLabel-label": {
                        fontFamily: '"Inter", sans-serif',
                    },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    fontFamily: '"Inter", sans-serif',
                },
                label: {
                    fontFamily: '"Inter", sans-serif',
                    fontSize: "0.875rem",
                },
            },
        },
    },
};

const theme = createTheme(themeOptions);
export default theme;
